import type { HTMLAttributes } from 'react';
import cx from 'classnames';
import { useTranslation } from 'react-i18next';
import { Logo, useTheme } from '@ui';

interface PublicPageLogoProps extends HTMLAttributes<HTMLAnchorElement> {
  className?: string;
}

export const PublicPageLogo = ({ className, ...props }: PublicPageLogoProps) => {
  const { t } = useTranslation();
  const { bgColorSecondary } = useTheme();

  return (
    <a
      href={t('share_link.url')}
      target="_blank"
      rel="noopener noreferrer"
      className={cx(className, 'flex w-fit items-end gap-1')}
      {...props}
    >
      <Logo className="block w-[96px] h-auto sm:w-[150px]" />
      <span
        className="text-[10px] leading-3 text-base-100 rounded-lg px-1 py-[2px] w-fit"
        style={{ backgroundColor: bgColorSecondary }}
      >
        {t('common.beta')}
      </span>
    </a>
  );
};
